import { GetApp } from "../../App"
import { Block, BlockField, BlockRow } from "../../Components/Block"
import { Icon, Icons } from "../../Components/Icon"
import { LoginForgotPasswordViewProps } from "./Params"

export function LoginForgotPasswordView({ forgotPassword, loginError, loading, showPassword, setShowPassword, submitReset, submitResetComplete, setForgotPassword, onEdited }: LoginForgotPasswordViewProps) {
  const app = GetApp()!;
  const t = app.getT("LoginView");

  return (
    <div className="forgot-password">
      <h4 className="text_on_box">{t("forgot_password")}</h4>

      <Block className="forgot-password-block">
        {forgotPassword == true ? (
          <>
            <BlockRow><p>{t("forgot_password_email")}</p></BlockRow>
            <form className="LoginView-form" onSubmit={submitReset}>
              {loginError && <div className="LoginView-error">{t(`error_${loginError}`)}</div>}
              <BlockRow>
                <BlockField label={t("form_email")} labelFor={"login_email"}>
                  <input id="login_email" name="email" type="email" autoComplete={app.cloudSession() ? "username" : "off"} />
                </BlockField>
              </BlockRow>

              <BlockRow className="row-right">
                <button className="button submit-button" disabled={loading} type="submit">{t(loading ? "form_submit_forgot_password_loading" : "form_submit_forgot_password")}</button>
              </BlockRow>
            </form>
          </>
        ) : forgotPassword == "success" ? (
          <>
            <BlockRow><p>{t("forgot_password_email_sent")}</p></BlockRow>
            <BlockRow className="row-right">
              <button className="button submit-button" onClick={() => setForgotPassword(false)}>{t("form_back_to_login")}</button>
            </BlockRow>
          </>
        ) : forgotPassword == "complete" ? (
          <>
            <BlockRow><p>{t("forgot_password_complete")}</p></BlockRow>
            <BlockRow className="row-right">
              <button className="button submit-button" onClick={() => setForgotPassword(false)}>{t("form_back_to_login")}</button>
            </BlockRow>
          </>
        ) : (
          <>
            <BlockRow><p>{t("forgot_password_new_password")}</p></BlockRow>
            <form className="LoginView-form" onSubmit={submitResetComplete}>
              {loginError && <div className="LoginView-error">{t(`error_${loginError}`)}</div>}

              <BlockRow>
                <BlockField label={t("form_new_password")} labelFor={"reset_password"}>
                  <span className="password-field">
                    <input id="reset_password" name="password" type={showPassword ? "text" : "password"} autoComplete={"off"} onChange={onEdited} />
                    <Icon icon={showPassword ? Icons.EyeOn : Icons.EyeOff} className="password-toggle" onClick={() => setShowPassword(!showPassword)} />
                  </span>
                </BlockField>
              </BlockRow>

              <BlockRow>
                <BlockField label={t("form_new_password_confirmation")} labelFor={"reset_password_confirmation"}>
                  <input id="reset_password_confirmation" name="passwordConfirmation" type="password" autoComplete={"off"} onChange={onEdited} />
                </BlockField>
              </BlockRow>

              <BlockRow className="row-right">
                <button className="button submit-button" disabled={loading} type="submit">{t(loading ? "form_submit_forgot_password_loading" : "form_submit_forgot_password")}</button>
              </BlockRow>
            </form>
          </>
        )}
      </Block>
    </div>
  );
}
